module.exports = __webpack_public_path__ + "static/media/vk.763b977a.svg";